<template>
  <div class="address-delivery">
    <page-header title="Доставка от двери до двери" title-in-breadcrumbs="Адресная доставка" />
    <div id="services" class="public-container public-container-mobile">
      <address-delivery-main />
      <div class="mt-110-90-70-70">
        <h2 class="vz-text-align-left">Расчет стоимости</h2>
        <vz-calculator promocode="VEZET15" />
      </div>
      <div class="address-delivery-sending my-70">
        <h3 class="vz-text-align-left">
          Что можно отправить "от двери до двери"
        </h3>
        <div class="public-text-line">
          груз, посылки, документы и т.д.
        </div>
      </div>
      <address-delivery-time />
      <public-info-grid
        rounded-style
        title-left
        :title="data.title"
        class="mt-60 mb-110"
        :items="items"
      />
      <public-service-links-grid 
        text-only 
        :items="linksItems" 
        class="mb-110-90-70-70"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {getPageContent} from '~/api/content';
import {PublicInfoGridItem} from '~/types/public'
import PageHeader from '~/components/public/page-header.vue'
import PublicInfoGrid from '~/components/public/public-info-grid.vue'
import VzCalculator from '~/components/public/order/vz-calculator.vue'
import PublicServiceLinksGrid from '~/components/public/public-service-links-grid.vue'
import AddressDeliveryMain from '~/components/public/address-delivery/address-delivery-main.vue'
import AddressDeliveryTime from '~/components/public/address-delivery/address-delivery-time.vue'

const data = (await getPageContent('/address-delivery')).blocks?.services

const items = computed(() => [
  {
    title: data.driverDataTitle,
    text: data.driverDataText,
    icon: {
      url: '/svg/vz-person.svg',
      size: 36
    }
  },
  {
    title: data.multiPickupTitle,
    text: data.multiPickupText,
    icon: {
      url: '/svg/boxes.svg',
      size: 36
    },
    link: {
      title: 'Подробнее об условиях акции',
      to: { name: 'delivery-russia' }
    }
  },
  {
    title: data.individualTransportTitle,
    text: data.individualTransportText,
    icon: {
      url: '/svg/car/truck.svg',
      size: 36
    },
    warning: data.individualTransportWarning
  },
  {
    title: data.transportTitle,
    text: data.transportText,
    icon: {
      url: '/svg/crane.svg',
      size: 36
    }
  }
])

const linksItems: PublicInfoGridItem[] = [
  {
    title: 'Список терминалов',
    link: { to: { name: 'terminals' } }
  },
  {
    title: 'Доставка <span class="text-nowrap">малогабаритного груза</span>',
    link: { to: { name: 'shippingtypes-smallcargo' } }
  },
  {
    title: 'Доставка <span class="text-nowrap">негабаритного груза</span>',
    link: { to: { name: 'shippingtypes-oversized' } }
  },
  {
    title: 'Запрещенные грузы',
    link: { to: { name: 'prohibited-goods' } }
  },
]
</script>

<style lang="scss" scoped>
.address-delivery {

  :deep(.public-service-links-grid-items) {
    grid-template-columns: repeat(4, 1fr) !important;

    @media only screen and (max-width: $pub-sm) {
      grid-template-columns: 1fr 1fr !important;
    }

    @media only screen and (max-width: $pub-xs) {
      grid-template-columns: 1fr !important;
    }
  }

  .public-info-grid {
    @media only screen and (max-width: $pub-sm) {
      margin-top: 40px;
    }
  }
}
</style>
